export default __webpack_public_path__ + "static/media/android.74dcf616.svg";